<script>
	import {getText} from "../../../../share/utils";
	import { onMount } from "svelte";

	let decor;
	let scrolledBefore = 0;
	let transform = () => {};

	function animateDecor() {
		// right Page of "Now" container. So actual displayed page:
		const rightContainer = document.querySelector('.container > .right');
		let scrolled = rightContainer ? rightContainer.scrollTop : 0;
		if(scrolledBefore !== scrolled) {
			transform = (factor) => {
				return `translateY(${Math.max(-500, (decor.offsetTop - scrolled) * factor)}px)`;
			}
		}
		scrolledBefore = scrolled;
		requestAnimationFrame(animateDecor);
	}
	function decorInNowPage(element) {
		if(!element.parentElement) {
			return false;
		}
		return element.parentElement.classList.contains('now') || decorInNowPage(element.parentElement);
	}

	onMount(() => {
		if(decorInNowPage(decor)) {
			animateDecor();
		}
	})
</script>

<div class="page-aes marginbox">
	<div class="flex structure">
		<div class="flex row structure-3">
			<div class="flex element">
				<img loading="lazy" alt="AES HUB - Header"
					 src="./../img/20.AES_HUB/03.award_winning/screen.webp">
			</div>
		</div>
	</div>
	
	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="AES HUB - poster"
					 src="./../img/20.AES_HUB/03.award_winning/poster.webp">
			</div>

			<div class="flex element">
				<div class="text">
					<h2>{@html getText("20.03.03_h2")}</h2>
					<p class="caption green">Quelle: <a href="https://www.ft.com/leading-management-consultants-in-UK-2024" target="_blank">https://www.ft.com/leading-management-consultants-in-UK-2024</a></p>
				</div>
			</div>

			<div class="flex element awards">
<!--				<img class="award" style="flex: 172" loading="lazy"-->
				<img class="award" style="flex: 135" loading="lazy"
					 alt="AES HUB Award - Housebuilder award 2024"
					 src="./../img/20.AES_HUB/03.award_winning/Housebuilder.webp">
				<img class="award" style="flex: 348" loading="lazy"
					 alt="AES HUB Award - Financial Times: UK's Leading Management Consultants 2024"
					 src="./../img/20.AES_HUB/03.award_winning/FT_Leading_Management_Consultants.webp">
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<div class="text">
					<h2>{getText("20.03.01_h2")}</h2>
					<p class="caption">{getText("20.03.02_caption")}</p>
					<p class="caption green">Quelle: <a href="https://www.house-builder.co.uk/events/housebuilder-product-awards-2024/" target="_blank">https://www.house-builder.co.uk/events/housebuilder-product-awards-2024/</a></p>
				</div>
			</div>

			<div class="flex element decor" bind:this={decor}>
				<img class="back" style="transform: {transform(.7)}" loading="lazy" alt="AES HUB - Phone 1"
					 src="./../img/20.AES_HUB/01.decor/Phone_1_Mockup.webp">
				<img class="front" style="transform: {transform(.5)}" loading="lazy" alt="AES HUB - Phone 2"
					 src="./../img/20.AES_HUB/01.decor/Phone_2_Mockup.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;

		&.award {
			height: fit-content;
		}
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	.page-aes {
		h2 {
			margin-bottom: $media-gap;
		}
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}

		.awards {
			gap: $media-gap;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
			gap: $media-gap;
		}
		
		.structure-1 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			
			@include for-tablet-portrait-up {
				flex: 1;
			}

			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;

				&:last-of-type {
					@include for-tablet-portrait-up {
						margin-bottom: 0;
					}
				}
			}
		}
		
		.structure-2 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				flex: 1;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
			
			> .element:first-of-type {
				@include for-tablet-portrait-up {
					padding-right: 5vw;
				}
				
				@include for-desktop-up {
					p.caption {
						padding-right: 6vw;
					}
				}
			}
		}


		.structure-1,
		.structure-2 {
			@include for-tablet-portrait-up {
				justify-content: space-between;
			}
		}
		
		.structure-3 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			position: relative;
			
			.element:first-of-type {
				height: fit-content;
				padding-right: 5vw;
			}
			
			.badge {
				width: 35%;
				height: fit-content;
				position: absolute;
				top: 0;
				right: -2rem;
			}
		}
		
		.text {
			margin: 0;
		}
	}

	.decor {
		width: 100%;
		position: relative;
		//height: 100%;
		flex: 1;
		right: 0;
		z-index: -1;

		@include for-tablet-portrait-up {
			width: 25%;
		}

		@include for-tablet-landscape-up {
			width: 20%;
		}


		img {
			width: 90%;
			bottom: 0;
			height: auto;
			margin: 0;
			padding: 0;
			position: absolute;

			&.back {
				left: 0;
				bottom: -20%;
				aspect-ratio: 259 / 410;
			}
			&.front {
				bottom: 0%;
				right: -35%;
				aspect-ratio: 242 / 408;
				z-index: -1;
			}
		}
	}
</style>
